import React from "react";
import styles from "./Project.module.css";
import ProjectCard from "./ProjectCrad";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";
import refresh from "../../assets/refresh.png";
import reddit from "../../assets/reddit.png";
import redbus from "../../assets/redbus.png";
import sudoku from "../../assets/sudoku.png";
import crypto from "../../assets/crypto.png";
const Project = () => {
  const { mode } = React.useContext(ThemeContext);
  let data = [
    {
      title: "Masai Refresh",
      image: [refresh, "refresh"],
      about:
        "This app is the one stop destination for the masai students for there revision. ",
      links: [
        "https://github.com/masai-oss/Masai_Refresh",
        "https://refresh.masai.tech/",
      ],
      tech: ["React", "Material UI", "Redux", "Javascript", "Styled Component"],
    },
    {
      title: "Redbus Clone",
      image: [redbus, "redbus"],
      about:
        "A clone of one of the key player of online bus ticket booking service currently present in the market.",
      links: [
        "https://github.com/nitansh11/redbus",
        "https://redbus.netlify.app/",
      ],
      tech: [
        "React",
        "Material UI",
        "Redux",
        "Javascript",
        "MongoDB",
        "Express",
        "NodeJS",
      ],
    },
    {
      title: "Reddit Clone",
      image: [reddit, "Reddit clone SS"],
      about:
        "An Online Community for people who can search and and jointhere interested community. ",
      links: [
        "https://github.com/kumarrohan2804/delta",
        "https://rohan-reddit-clone.netlify.app/",
      ],
      tech: ["React", "Material UI", "Redux", "Javascript", "Heroku"],
    },
    {
      title: "Sudoku Solver",
      image: [sudoku, "Sudoku png"],
      about: "An online fun to play sudoku games",
      links: [
        "https://github.com/kumarrohan2804/sudoku",
        "https://sudoku-rohan.netlify.app/",
      ],
      tech: ["React", "Material UI", "Javascript"],
    },
    {
      title: "Crypto-Sheets",
      image: [crypto, "Crypto png"],
      about:
        "All the Listing of cryptocurrency now a click away. Pick ur favourite currency",
      links: [
        "https://github.com/kumarrohan2804/crypto-sheets",
        "https://crypto-sheets.netlify.app",
      ],
      tech: ["React", "Styled Component", "Javascript", "Axios"],
    },
  ];
  return (
    <div className={styles.container} style={{ border: "none" }} id="projects">
      <div
        className={styles.heading}
        style={
          mode === "dark" ? { color: "#fff" } : { color: "rgb(109, 131, 242)" }
        }
      >
        Projects
      </div>
      <div className={styles.aligner}>
        {data?.map((item, i) => {
          return (
            <ProjectCard
              key={i}
              title={item.title}
              about={item.about}
              image={item.image}
              links={item.links}
              tech={item.tech}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Project;
